import { createTheme } from '@mui/material/styles';
import { faIR } from '@mui/material/locale';

// Hot fix: This way is not perfect way but works. We should find another way to do this...
faIR.components.MuiTablePagination.defaultProps.labelDisplayedRows = ({ from, to, count }) =>
  `${from}–${to} از ${count !== -1 ? count : ` بیشتر از${to}`}`;

const MUIThemeProvider = createTheme({
  direction: 'rtl',
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#6076E2',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#6076E2',
          },
          fontWeight: '700',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: '1px 1px 4px 1px rgba(0, 0, 0, 0.035)!important',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          span: {
            display: 'flex',
            justifyContent: 'space-between',
            minWidth: 'max-content',
            minInlineSize: 'max-content',
          },
        },
        root: {
          fontSize: '13px',
          padding: '6px 8px',
          borderBottom: '0',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflowY: 'visible',
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: '0 !important',
        },
        root: {
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#343B71',
      dark: '#281A52',
      contrastText: '#FFF',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    info: {
      main: '#3815a4',
      dark: '#32354F',
      light: '#6438E5',
    },
    secondary: {
      light: '#F6C121',
      main: '#F6AE2D',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#FFF',
    },
    action: {
      main: '#626262',
    },
    purple: {
      main: '#221D50',
    },
    warning: {
      main: '#F6C121',
    },
    grey: {
      A100: '#f5f5f5',
    },
    error: {
      main: '#F44336',
    },
    success: {
      main: '#74AF03',
    },

    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
}, faIR);

export default MUIThemeProvider;
